import { createRoot } from "react-dom/client";
import App from "./App.tsx";

import "./index.css";
import "./lightMode.css";
// import "./index-lzzI3VuC.css";

// Smooth scrolling for the entire document
document.documentElement.style.scrollBehavior = "smooth";

createRoot(document.getElementById("root")!).render(<App />);
